module.exports = __webpack_public_path__ + "assets/img/Integrity_badge_Light_NO.9979827b.png";